export const TREND_VALUES = [
	["#000000", "#BABBBE"],
	["#2A8703", "#EAF3E6"],
	["#AF2F00", "#FCE8E9"],
]
export const CHART_DATA_KEY = "variationDifference"

export const PENETRATION_SUMMARY_TITLE_ID =
	"phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.title"
export const ID_INTL_FILTER = "phronesis.filters.pluralize."
export const CURRENT_VENDOR_INDEX = 0
export const PREVIOUS_VENDOR_INDEX = 2
export const CURRENT_WALMART_INDEX = 2
export const PREVIOUS_WALMART_INDEX = 4
export const CURRENT_REACH_INDEX = 4
export const PREVIOUS_REACH_INDEX = 6
